/**
 * Whether this device has seen the intro (the backstory Agent Alex tells before the first mission,
 * features/intro). Kept apart from progress: a reset of the stars does not replay the story.
 */
const KEY = 'foe-names.intro.v1';

export function introSeen(): boolean {
  try {
    return localStorage.getItem(KEY) === 'seen';
  } catch {
    return false;
  }
}

export function markIntroSeen(): void {
  try {
    localStorage.setItem(KEY, 'seen');
  } catch {
    // Storage blocked: the intro shows again next visit.
  }
}

/** Debug and "Start over": the intro shows again. */
export function forgetIntro(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Storage blocked.
  }
}
